"use client";

import { useRouterState } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { PersonIcon } from "@/components/appIcons";
import { GuestSignupDialog } from "@/components/guest-signup-dialog";
import { MessagingPromptGate } from "@/components/messaging/messaging-prompt-gate";
import { isAuthPath, shouldShowMessagingPrompt } from "@/components/shouldShowMessagingPrompt";
import { Button } from "@/components/ui/button";
import { useGuestSignupDialog } from "@/hooks/use-guest-signup-dialog";
import { useViewer } from "@/hooks/use-viewer";

export function GlobalGuestConversion() {
  const t = useTranslations("globals.auth");
  const viewer = useViewer();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const { openGuestSignup, setGuestSignupOpen, signupOpen } = useGuestSignupDialog();
  const authPath = isAuthPath(pathname);
  const showGuestBanner = viewer.isGuest && !authPath;
  const showMessagingPrompt = shouldShowMessagingPrompt(pathname, signupOpen);
  const hideGeneralMessagingPromptOnMobile = pathname === "/search";

  return (
    <>
      {showGuestBanner && (
        <aside className="border-b border-primary/20 bg-primary/8 px-4 py-3 md:px-6">
          <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-3 sm:flex-row sm:items-center">
            <div className="flex flex-1 items-start gap-3">
              <PersonIcon className="mt-0.5 shrink-0 text-xl text-primary" decorative />
              <div>
                <p className="text-sm font-bold text-foreground">{t("guestBannerTitle")}</p>
                <p className="mt-0.5 text-sm text-muted-foreground">
                  {t("guestBannerDescription")}
                </p>
              </div>
            </div>
            <Button
              type="button"
              className="min-h-10 shrink-0 font-bold"
              onClick={() => {
                openGuestSignup();
              }}
            >
              {t("guestBannerCta")}
            </Button>
          </div>
        </aside>
      )}
      {showMessagingPrompt && (
        <MessagingPromptGate
          hideGeneralOnMobile={hideGeneralMessagingPromptOnMobile}
          viewer={viewer}
        />
      )}
      <GuestSignupDialog open={signupOpen} onOpenChange={setGuestSignupOpen} />
    </>
  );
}
